import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home.vue'
import detail from '../views/detail.vue'
import search from '../views/search.vue'
import toutiao from '../views/toutiao.vue'
import huanqiu from '../views/huanqiu.vue'
import jishu from '../views/jishu.vue'
import guandian from '../views/guandian.vue'
import baogao from '../views/baogao.vue'
import yuntu from '../views/yuntu3.vue'
import shijian from '../views/shijian.vue'
import zhengce from '../views/zhengce.vue'
import theme from '../views/theme.vue'
import ztshuzijichusheshi from '../views/zt-shuzijichusheshi'
import ztgongyehulianwang from '../views/zt-gongyehulianwang'
import ztzhihuiwuliu from '../views/zt-zhihuiwuliu'
import ztshuzijinrong from '../views/zt-shuzijinrong'
import ztshuzizhengwu from '../views/zt-shuzizhengwu'
import ztshuzizhili from '../views/zt-shuzizhili'
import ztshuzimaoyi from '../views/zt-shuzimaoyi'
import ztshuzixiangcun from '../views/zt-shuzixiangcun'
import ztrengongzhineng from '../views/zt-rengongzhineng.vue'
import ztzhihuichengshi from '../views/zt-zhihuichengshi.vue'
import ztdianzishangwu from '../views/zt-dianzishangwu.vue'
import ztdashuju from '../views/zt-dashuju.vue'
import ztyunjisuan from '../views/zt-yunjisuan.vue'
import ztwulianwang from '../views/zt-wulianwang.vue'
import ztguojihezuo from '../views/zt-guojihezuo.vue'
import ztshujuziyuan from '../views/zt-shujuziyuan.vue'
import ztshuzianquan from '../views/zt-shuzianquan.vue'
import ztshuzichuangxintixi from '../views/zt-shuzichuangxintixi.vue'
import ztshuzishengtaiwenming from '../views/zt-shuzishengtaiwenming.vue'
import ztshuziwenhua from '../views/zt-shuziwenhua.vue'
import ztzhihuijiaoyu from '../views/zt-zhihuijiaoyu.vue'
import ztzhihuinongye from '../views/zt-zhihuinongye.vue'
import ztzhihuiyiliao from '../views/zt-zhihuiyiliao.vue'
// import activity from '../views/activity.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: home,
		meta:{
			auth:false
		}
  },
	// {
	//   path: '/activity',
	//   name: 'activity',
	//   component: activity,
	// 	meta:{
	// 		auth:false
	// 	}
	// },
	{
	  path: '/toutiao',
	  name: 'toutiao',
	  component: toutiao,
		meta:{
			auth:true
		}
	},
	{
	  path: '/huanqiu',
	  name: 'huanqiu',
	  component: huanqiu,
		meta:{
			auth:true
		}
	},
	{
	  path: '/jishu',
	  name: 'jishu',
	  component: jishu,
		meta:{
			auth:true
		}
	},
	{
	  path: '/guandian',
	  name: 'guandian',
	  component: guandian,
		meta:{
			auth:true
		}
	},
	{
	  path: '/baogao',
	  name: 'baogao',
	  component: baogao,
		meta:{
			auth:true
		}
	},
	{
	  path: '/yuntu/:column?',
	  name: 'yuntu',
	  component: yuntu,
		meta:{
			auth:true
		}
	},
	{
	  path: '/shijian',
	  name: 'shijian',
	  component: shijian,
		meta:{
			auth:true
		}
	},
	{
	  path: '/zhengce',
	  name: 'zhengce',
	  component: zhengce,
		meta:{
			auth:true
		}
	},
	{
	  path: '/theme/:searchword/:pagetype/:colid?',
	  name: 'theme',
	  component: theme,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztshuzijichusheshi',
	  name: 'ztshuzijichusheshi',
	  component: ztshuzijichusheshi,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztgongyehulianwang',
	  name: 'ztgongyehulianwang',
	  component: ztgongyehulianwang,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztzhihuiwuliu',
	  name: 'ztzhihuiwuliu',
	  component: ztzhihuiwuliu,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztshuzijinrong',
	  name: 'ztshuzijinrong',
	  component: ztshuzijinrong,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztshuzizhengwu',
	  name: 'ztshuzizhengwu',
	  component: ztshuzizhengwu,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztshuzizhili',
	  name: 'ztshuzizhili',
	  component: ztshuzizhili,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztshuzimaoyi',
	  name: 'ztshuzimaoyi',
	  component: ztshuzimaoyi,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztshuzixiangcun',
	  name: 'ztshuzixiangcun',
	  component: ztshuzixiangcun,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztrengongzhineng',
	  name: 'ztrengongzhineng',
	  component: ztrengongzhineng,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztzhihuichengshi',
	  name: 'ztzhihuichengshi',
	  component: ztzhihuichengshi,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztdianzishangwu',
	  name: 'ztdianzishangwu',
	  component: ztdianzishangwu,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztdashuju',
	  name: 'ztdashuju',
	  component: ztdashuju,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztyunjisuan',
	  name: 'ztyunjisuan',
	  component: ztyunjisuan,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztwulianwang',
	  name: 'ztwulianwang',
	  component: ztwulianwang,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztguojihezuo',
	  name: 'ztguojihezuo',
	  component: ztguojihezuo,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztshujuziyuan',
	  name: 'ztshujuziyuan',
	  component: ztshujuziyuan,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztshuzianquan',
	  name: 'ztshuzianquan',
	  component: ztshuzianquan,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztshuzichuangxintixi',
	  name: 'ztshuzichuangxintixi',
	  component: ztshuzichuangxintixi,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztshuzishengtaiwenming',
	  name: 'ztshuzishengtaiwenming',
	  component: ztshuzishengtaiwenming,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztshuziwenhua',
	  name: 'ztshuziwenhua',
	  component: ztshuziwenhua,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztzhihuijiaoyu',
	  name: 'ztzhihuijiaoyu',
	  component: ztzhihuijiaoyu,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztzhihuinongye',
	  name: 'ztzhihuinongye',
	  component: ztzhihuinongye,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztzhihuiyiliao',
	  name: 'ztzhihuiyiliao',
	  component: ztzhihuiyiliao,
		meta:{
			auth:true
		}
	},
	{
	  path: '/detail/:id/:toutiaoflag?',
	  name: 'detail',
	  component: detail,
		meta:{
			auth:true
		}
	},
	{
	  path: '/search/:searchword?',
	  name: 'search',
	  component: search,
		meta:{
			auth:true
		}
	},
	{
	  path: '/*',
	  redirect: '/'
	},
]

const router = new VueRouter({
	mode: 'history',
  routes
})

export default router
